import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../contexts/AppContext'
import Message from './Message'

import { Link } from 'react-router-dom'


const Unauthorized = ({ match, history }) => (
    <Message
        title="Unauthorized"
        description="You are unauthorized to access this page."
        action={{to: '/', label: 'Home page'}}
    />
)

export default Unauthorized
